module.exports = __webpack_public_path__ + "img/waze.cbcb18bc.svg";